module.exports = __webpack_public_path__ + "img/CLVHelp6.c438bb9f.png";